import { createSelector } from '@ngrx/store';

import { selectFehSolarPanelsState } from '../feh-solar-panels.state';
import { solarPanelsWizardKey } from './solar-panels-wizard.reducer';
import type { SolarPanelsWizardFormValues } from './form-ids';

const selectSolarPanelsWizardState = createSelector(
  selectFehSolarPanelsState,
  (state) => state[solarPanelsWizardKey]
);

export const selectSolarPanelsWizardSubmitState = createSelector(
  selectSolarPanelsWizardState,
  (state) => state.submitState
);

export const selectSolarPanelsWizardFormValues = createSelector(
  selectSolarPanelsWizardState,
  (state) => state.formValues as SolarPanelsWizardFormValues
);

export const selectSolarPanelsWizardAnalyticsPayload = createSelector(
  selectSolarPanelsWizardFormValues,
  (state) => ({
    consumption: state?.consumption,
  })
);
